import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWhiteboard2"><Path d="M12.9997 2H10.9997V4H2V6H2.99971V18H2V20H22V18H20.9997V6H22V4H12.9997V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWhiteboard2;
